import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { Icon } from '@material-ui/core';
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useEffect } from 'react';
import TransferenciaForm from '../../../transferencia/components/modal/cadastro/content/TransferenciaForm';
import TransferenciaSchema from '../../../transferencia/components/modal/cadastro/schemas/TransferenciaSchema';
import { ConciliacaoContext } from '../ConciliacaoContext';
import { ConciliacaoModal } from './ConciliacaoModal';

const CadastrarTransferencia = ({ origemConciliacao }) => {
  const [modal, setModal] = useContext(ConciliacaoContext).modal;
  const [, setConciliacao] = useContext(ConciliacaoContext).conciliacao;
  const [transferencia, setTransferencia] = useContext(ConciliacaoContext).transferencia;

  const getInitialValues = (registro) => ({
    ...registro,
    id: registro?.id,
    contaOrigemId: registro?.contaOrigemId,
    contaDestinoId: registro?.contaDestinoId,
    valor: registro?.valor,
    data: registro?.data,
    descricao: registro?.descricao,
  });

  const onSubmitForm = async (transferencia) => {};

  const formik = useFormik({
    validationSchema: TransferenciaSchema,
    initialValues: getInitialValues(transferencia),
    onSubmit: onSubmitForm,
    validateOnChange: true,
    validateOnBlur: true,
  });

  const close = () => {
    setConciliacao({});
    setTransferencia({});
    formik.resetForm(getInitialValues({}));
    setModal('');
  };

  const handleCloseModal = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const { resetForm } = formik;
  useEffect(() => {
    resetForm(getInitialValues(transferencia));
  }, [transferencia, resetForm]);

  return (
    <SimpleDialog fullScreen open={modal === ConciliacaoModal.cadastrarTransferencia} onClose={handleCloseModal}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          fullScreen
          header={{
            title: 'Cadastro de transferência',
            icon: <Icon>compare_arrows</Icon>,
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCloseModal}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Salvar
                </SaveButton>
              </>
            ),
          }}
          content={<TransferenciaForm origemConciliacao={origemConciliacao} />}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default CadastrarTransferencia;
